import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { YearService } from '../../../../shared-components/year/year.service';
import { UserPreferencesService } from '../../../../shared-components/user-preferences/user-preferences.service';
import { SchoolYearSettings } from '../../../../shared-components/year/school-year-settings.model';
import { ReportingService } from '../../reporting.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CourseTerm } from '../../../../student360/student-schedule/course-term.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { StudentAttachment } from '../../../student-attachment/student-attachment.model';
import { System } from '../../../../shared-components/System';
import { ReportQueueComponent } from '../../report-queue/report-queue.component';
import { ReportParameterV9 } from '../../models/report-parameter-v9.model';
// import { TeacherPreview } from '../../models/teacher-preview.model';

import { LookupService } from '../../../../shared-components/lookup/lookup.service';


import { DataSource } from '../../models/data-source.model';
import { v9ReportParameterName } from '../../reporting.service';
import { ClassroomSummary } from '../../../../classroom360/classroom-summary/models/classroom-summary.model';

@Component({
    selector: 'app-gradebook-assignments-by-standard',
    templateUrl: './gradebook-assignments-by-standard.component.html',
    styleUrls: ['./gradebook-assignments-by-standard.component.css'],
})
export class GradebookAssignmentsByStandardComponent implements OnInit, OnDestroy {
    dialogRef: MatDialogRef<GradebookAssignmentsByStandardComponent>;
    subscriptions: Subscription[] = [];
    schoolYearSettings: SchoolYearSettings;
    reportParameter = new ReportParameterV9();
    term: CourseTerm;
    ErrorCount: 0;
    parameters = [];
    param = [];
    errors: ErrorList[] = [];
    numberMask = {};
    showRunButton = true;
    reportType: number;
    reportName: string;
    // reportTitle: string;
    reportTitleInSystem: string;
    // userPreferencePageName = '/GradebookAssignmentsByStandard.aspx'; // must match what's in UserPreferences DTO
    workflowReport = false;
    inDebugMode = false;
    siteSectionIds = '';
    siteYearId: number;
    courses: DataSource[] = [];
    selectedCourse: string;
    departments: DataSource[] = [];
    selectedDepartment: string;
    teacher: string;
    allCourses: ClassroomSummary[] = [];
    // userPreferences: AttendanceHistoryByStudentPreferences; // AttendanceHistoryByClassPreferences;

    // field refs

    @ViewChild('ReportTitle', { read: ElementRef, static: true }) reportTitle: ElementRef;
    @ViewChild('Select', { read: ElementRef }) select: ElementRef;
    @ViewChild('FromPeriod', { read: ElementRef }) fromPeriod: ElementRef;
    @ViewChild('ToPeriod', { read: ElementRef }) toPeriod: ElementRef;
    @ViewChild('UpdateDisplay', { read: ElementRef }) updateDisplay: ElementRef;

    // grid
    gridDataExists: boolean;
    dataSource: MatTableDataSource<any>;
    gridColumns: string[] = ['selectAllCourses', 'Period', 'TermCode', 'SubjectCode', 'Section', 'AbbreviatedTitle', 'TeacherName', 'StudentCount', 'DaysGroupDescription'];


    // enums

    v9parameterName = v9ReportParameterName; // parameter name enum
    selectedTeacher: string;
    teachers: DataSource[] = [];

    filteredCourses: DataSource[] = [];
    showDepartment = false;
    userIsTeacher: boolean;
    selectedFacultyStaffId: number;

    constructor(
        private dialog: MatDialog,
        gradebookAssignmentsByStandardDialogRef: MatDialogRef<GradebookAssignmentsByStandardComponent>,
        private loginService: LoginService,
        private yearService: YearService,
        private userPreferencesService: UserPreferencesService,
        private reportingService: ReportingService,
        private lookupService: LookupService,
    ) {
        this.dialogRef = gradebookAssignmentsByStandardDialogRef;
    }

    ngOnInit() {

        this.inDebugMode = this.reportingService.inDebugMode;
        this.numberMask = this.reportingService.getNumberMask();

        this.siteYearId = this.yearService.defaultYear.SiteYearId;

        // report specific settings
        this.reportType = 2;
        this.reportName = 'CreateGradebookAssignmentsByObjectiveReport';
        this.reportTitleInSystem = 'Gradebook Assignments By Standard';
        this.reportParameter.ReportTitle = this.reportTitleInSystem;

        this.reportParameter.TermId = 0;

        this.showDepartment = false;
        this.userIsTeacher = this.reportingService.currentUser.UserIsTeacher;
        if (this.userIsTeacher) {
            this.showDepartment = false;
            this.selectedTeacher = this.reportingService.currentUser.LastName + ', ' + this.reportingService.currentUser.FirstName;
        } else {
            this.showDepartment = true;
        }

        this.populateParameters();

    }

    ngOnDestroy() {
        // unsubscribe

    }

    selectTeacher(teacher: DataSource) {
        this.getFilteredCourses();

        if (this.reportingService.inDebugMode) {
            console.log(teacher);
        }

        if (teacher.ValueField == '') {
            this.showDepartment = true;
        } else {
            this.showDepartment = false;
        }

        // if (this.selectedTeacher == '') {
        //     this.showDepartment = false;
        // } else {
        //     this.showDepartment = true;
        // }
    }

    selectDepartment(dept: any) {
        this.getFilteredCourses();
    }

    termChanged() {
        this.getMyClasses();
    }

    getFilteredCourses() {

        this.filteredCourses = [];
        // Add 'All' for courses
        const dataSourceAll = new DataSource();
        dataSourceAll.TextField = ' All';
        dataSourceAll.ValueField = '0';
        dataSourceAll.Id = '0';
        this.filteredCourses.push(dataSourceAll);

        if (this.selectedTeacher == undefined || this.selectedTeacher == null || this.selectedTeacher == '') {
            return; // we only populate course dropdown if a teacher is selected
        }

        for (let x = 0; x < this.allCourses.length; x++) {
            // if (this.allCourses[x].Instructor == 'Mathman, Jim') {
            //     console.log(this.allCourses[x]);
            // }
            if (this.reportParameter.TermId > 0 && this.allCourses[x].TermId != this.reportParameter.TermId) {
                continue;
            }
            if (this.selectedTeacher > '') {
                if (this.allCourses[x].Instructor != this.selectedTeacher) {
                    continue;
                }
            }
            // if (this.selectedDepartment > '' && this.selectedDepartment != '0' ) {
            // if (this.allCourses[x]. != this.selectedDepartment) {
            //     continue;
            // }
            // }
            const course = new DataSource();
            course.TextField = this.allCourses[x].SubjectCode + '-' + this.allCourses[x].Course;
            course.ValueField = this.allCourses[x].SubjectId.toString();
            course.Id = this.allCourses[x].Id.toString();
            this.selectedFacultyStaffId = this.allCourses[x].TeacherId;
            this.filteredCourses.push(course);

        }

    }

    populateParameters() {

        this.getSchoolYearSettings();
        this.getLookups();
        this.getTerms();
        // this.getMyClasses();
        if (!this.reportingService.currentUser.UserIsTeacher) {
            this.getDepartments();
        }
        // this.getFilteredCourses();
    }

    getSchoolYearSettings() {
        this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(data => {
            this.schoolYearSettings = data;
            // this.reportParameter.isValueChange = false;
            // this.reportParameter.isReportList = false;
            // this.reportParameter.PrintDate = formatDate(new Date, 'MM/dd/yyyy', 'en-US');
            // this.reportParameter.AttendanceDate = moment(this.yearService.defaultYear.CurrentAttendanceDate).format('MM/DD/YYYY');
            // this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
            // this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;

            // this.reportParameter.TermId = 0; // Default to All
            // this.refreshGrid();
        });
    }

    getLookups() {

        // this.subscriptions.push(
        //   this.reportingService.getResidencyCodesLookup().subscribe(lookups => {
        //     this.reportParameters.ResidencyCodes = lookups;
        //   })

        // );

    }

    getDepartments() {
        this.reportingService.getDistrictDepartmentsReadForGradebookAssignmentsLookup(this.siteYearId).subscribe(departments => {

            this.departments = [];

            for (let x = 0; x < departments.length; x++) {
                const dataSource = new DataSource();
                dataSource.TextField = departments[x].CodeDescription;
                dataSource.ValueField = departments[x].Code;
                dataSource.Id = departments[x].Id.toString();
                this.departments.push(dataSource);
            }

            if (this.departments.length > 0) {
                this.selectedDepartment = departments[0].Code;
            }


            // const dataSourceAll = new DataSource();
            // dataSourceAll.TextField = ' All';
            // dataSourceAll.ValueField = '0';
            // dataSourceAll.Id = '0';
            // this.departments.push(dataSourceAll);

            // this.selectedDepartment = '0'; // default to All });
        });
    }

    getTerms() {
        this.reportingService.getTermsforCourses(0, this.yearService.defaultYear.SiteYearId).subscribe(data => {
            this.reportParameter.Terms = data; // .filter(function (element) { return (element.TermTypeId != 2); });
            // this.term = new CourseTerm();
            // this.term.Id = 0;
            // this.term.LongDescription = ' All Terms';
            // this.reportParameter.Terms.push(this.term);

            this.reportParameter.AddTermAll();
            // this.term.Id = 0;

            // if (this.inDebugMode) {
            //     console.log(this.reportParameter.Terms);
            // }

            // termId: number, viewId: number, isTeacher: boolean, includeAllCourses: boolean, dateItem: Date

            this.getMyClasses();
        });
    }

    getMyClasses() {
        //  const termId = 0;

        // console.log(this.reportParameter.TermId);

        const currentDate = this.yearService.defaultYear.CurrentAttendanceDate;

        this.reportingService.getMyClasses(this.reportParameter.TermId, 0, this.reportingService.currentUser.UserIsTeacher, true, currentDate).subscribe(courses => {

            // console.log(courses);
            courses = this.getUniqueCourses(courses);
            // console.log(courses);
            // console.log(this.selectedTeacher);

            if (this.selectedTeacher != null || this.selectedTeacher != undefined && this.selectedTeacher > '') { // we are only populating course dropdown if a teacher is selected
                for (let x = 0; x < courses.length; x++) {
                    // console.log('ADDING COURSES');
                    const dataSource = new DataSource();
                    dataSource.TextField = courses[x].SubjectCode + '-' + courses[x].Course;
                    dataSource.ValueField = courses[x].SubjectId.toString();
                    dataSource.Id = courses[x].Id.toString();

                    this.courses.push(dataSource);
                }
            }

            // Add 'All' for courses
            const dataSourceAll = new DataSource();
            dataSourceAll.TextField = ' All';
            dataSourceAll.ValueField = '0';
            dataSourceAll.Id = '0';
            this.courses.push(dataSourceAll);

            this.selectedCourse = '0'; // default to All

            // termId: number, viewId: number, isTeacher: boolean, includeAllCourses: boolean, dateItem: Date

            this.teachers = [];
            if (!this.reportingService.currentUser.UserIsTeacher) {
                const ds = new DataSource();
                ds.TextField = 'All'; // '';
                ds.ValueField = ''; // = courses[x].Instructor;
                this.teachers.push(ds);
                this.selectedTeacher = '';
            }

            for (let x = 0; x < courses.length; x++) {

                if (courses[x].Instructor > '') {

                    // for (let y = 0; y < this.teachers.length; y++) {
                    const tempUsers = this.teachers.find(t => t.TextField == courses[x].Instructor);
                    if (tempUsers == null || tempUsers == undefined) {
                        // this.teachers.push(this.ReportBatches[x].AddedByName);
                        const dataSource = new DataSource();
                        dataSource.TextField = courses[x].Instructor;
                        dataSource.ValueField = courses[x].Instructor;
                        this.teachers.push(dataSource);
                    }
                    // }
                    // const dataSource = new DataSource();
                    // dataSource.TextField = courses[x].Instructor;
                    // dataSource.ValueField = courses[x].Instructor;
                    // this.teachers.push(dataSource);
                }
            }

            this.allCourses = courses;
            this.getFilteredCourses();

            if (this.reportingService.currentUser.UserIsTeacher) {
                this.selectedTeacher = this.reportingService.currentUser.LastName + ', ' + this.reportingService.currentUser.FirstName;
                //  console.log(this.selectedTeacher);
            }
        });
    }

    // teacherChanged(teach: DataSource) {
    //     this.selectedTeacher = teach.ValueField;
    //     if (this.selectedTeacher == '') {
    //         this.showDepartment = false;
    //     } else {
    //         this.showDepartment = true;
    //     }
    // }

    getUniqueCourses(origArr) {
        // return origArr;

        const newArr = [];
        const origLen = origArr.length;
        // found, x, y;

        for (let x = 0; x < origLen; x++) {
            // if (origArr[x].Instructor == 'Mathman, Jim') {
            //     console.log(origArr[x]);
            // }
            // let found =  false; // = undefined;

            const rec = newArr.find(c => c.SubjectCode == origArr[x].SubjectCode && c.Course == origArr[x].Course && c.Instructor == origArr[x].Instructor);
            // if (origArr[x].Instructor == 'Mathman, Jim') {
            //     console.log(rec);
            // }
            if (rec == null || rec == undefined) {
                newArr.push(origArr[x]);
            }
            // for (let y = 0; y < newArr.length; y++) {
            //     if (origArr[x].SubjectCode === newArr[y].SubjectCode && origArr[x].Course === newArr[y].Course) {
            //        // if (origArr[x].SubjectCode === newArr[y].SubjectCode && origArr[x].Course === newArr[y].Course) {
            //         found = true;
            //         break;
            //     }
            // }
            // if (!found) {
            //     if (origArr[x].Instructor == 'Mathman, Jim') {
            //         console.log(origArr[x]);
            //     }
            //     newArr.push(origArr[x]);
            // }
        }
        return newArr;
    }


    runReportClick() {
        this.checkErrors();

        if (this.errors.length == 0) {
            this.setReportParameters();
            this.saveUserPreferences();

            if (this.workflowReport) {
                this.addToReportQueue();
            } else {
                this.openStudentAttachment();
            }

            this.dialogRef.close();
        }

    }




    checkErrors() {
        this.errors = [];


        // Report Title

        if (!this.reportingService.hasStringValueNotEmpty(this.reportParameter.ReportTitle)) {
            this.errors.push({
                fieldName: 'Report Title',
                errorMsg: 'Field is required',
                fieldRef: this.reportTitle
            });
        }



    }

    setReportParameters() {
        // this.reportParameter.PrintDate = this.reportingService.getMonthDayYear(new Date()).toString();

        this.param = [];
        this.addCoreParameters();


        // report specific parameters

        // lngDistrictDepartmentId
        // strDepartmentDesc
        // lngDistrictSubjectId
        // strSubjectDesc

        let dept = '0';
        if (this.selectedTeacher == '') {
            dept = this.selectedDepartment;
            this.param.push({ ParamName: 'strStaffUserName', ParamStringValue: this.reportingService.currentUser.LastName + ', ' + this.reportingService.currentUser.FirstName });
            this.param.push({ ParamName: 'lngFacultyStaffId', ParamStringValue: 0 }); // TeacherId
        }
        else {
            this.param.push({ ParamName: 'strStaffUserName', ParamStringValue: this.selectedTeacher });
            this.param.push({ ParamName: 'lngFacultyStaffId', ParamStringValue: this.selectedFacultyStaffId }); // TeacherId

        }


        //        this.param.push({ ParamName: 'lngDistrictDepartmentId', ParamStringValue: dept });
        this.param.push({ ParamName: 'lngDistrictDepartmentId', ParamStringValue: 0 });
        this.param.push({ ParamName: 'strDepartmentDesc', ParamStringValue: '' });
        this.param.push({ ParamName: 'lngDistrictSubjectId', ParamStringValue: this.selectedCourse });

        if (this.selectedCourse == '0') {
            this.param.push({ ParamName: 'strSubjectDesc', ParamStringValue: 'All' });
        }
        else {
            const course = this.courses.find(c => c.ValueField == this.selectedCourse);

            this.param.push({ ParamName: 'strSubjectDesc', ParamStringValue: course.TextField });
        }

        if (this.reportingService.inDebugMode) {
            console.log(this.param);
        }


        this.parameters = [];
        this.parameters.push(JSON.stringify(this.param));

    }


    addCoreParameters() {
        this.reportingService.addCoreParametersV9
            (
                this.param,
                this.reportParameter.ReportTitle,
                this.reportType,
                // core parameter flags ()
                /* eslint-disable no-bitwise */
                this.v9parameterName.strReportDate |
                this.v9parameterName.strReportSiteHeader |
                this.v9parameterName.strReportTitle |
                this.v9parameterName.strSiteYearCode |
                this.v9parameterName.lngSiteYearId |
                // this.v9parameterName.strStaffUserName_LNFN |
                this.v9parameterName.strOutputFile_NOFILE |
                this.v9parameterName.strReportTime
                /* eslint-enable no-bitwise */
            );

    }

    saveUserPreferences() {

        // const UserPreferencesObj = this.userPreferences;
        // UserPreferencesObj.pub_strReportTitle = this.reportParameter.ReportTitle;
        // UserPreferencesObj.pub_intReportType = this.reportType; // C1

    }

    addToReportQueue() {
        //        this.reportingService.runV9Report(this.reportName, this.reportType, this.workflowReport, this.parameters).subscribe(response => {
        this.reportingService.runV9Report(this.reportName, this.reportType, this.workflowReport, this.parameters).subscribe(response => {
            setTimeout(() => {
                this.openReportQueueList();
            }, 500);
        }
            , err => {
                // On Error
                console.log(err);
            });
    }

    openReportQueueList() {
        const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
        });
    }



    openStudentAttachment() {
        // if (this.reportingService.inDebugMode) {
        //     console.log(this.parameters);
        // }
        const studentAttachment: StudentAttachment = {
            DocumentId: 0,
            DocumentName: this.reportName,
            DocumentBase64: '',
            DocumentMimeType: '',
            DocumentModuleName: '',
            ReportParameters: this.parameters,
            ReportType: this.reportType
        };
        window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
        window.open(System.baseUrl + 'studentattachment', '_blank');
    }


    closeClick() {
        this.dialogRef.close();
    }

}

